var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 35.5,
    rx: 17,
    ry: 16.5,
    fill: "#EAF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1053 13C35.0585 13 38.7441 14.0887 41.7639 16.1483C45.064 18.3991 47.4519 21.6633 48.8608 25.8481C49.1348 26.6569 48.9534 27.1596 48.7527 27.4389C48.5292 27.7503 48.1819 27.9289 47.8002 27.9289C47.3123 27.9289 46.874 27.6533 46.4966 27.1087C44.6409 24.423 42.0617 23.0613 38.8307 23.0613C34.1998 23.0613 29.1146 25.8135 25.6048 28.6034L28.4238 31.746C29.2331 32.6486 29.293 34.0077 28.5661 34.9778C28.0863 35.618 27.322 36 26.5214 36H11.0962C9.39195 36 8 34.6226 8 32.9069V17.4895C8 16.1029 9.12472 14.95 10.5417 14.95C11.1797 14.95 11.7899 15.1871 12.2599 15.6176L15.5534 18.6342C20.1737 14.9945 25.6631 13 31.1053 13Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8947 56C32.9415 56 29.2559 54.9113 26.2361 52.8517C22.936 50.6009 20.5481 47.3367 19.1392 43.1519C18.8652 42.3431 19.0466 41.8404 19.2473 41.5611C19.4708 41.2497 19.8181 41.0711 20.1997 41.0711C20.6877 41.0711 21.126 41.3467 21.5034 41.8913C23.3591 44.577 25.9383 45.9387 29.1693 45.9387C33.8002 45.9387 38.8854 43.1865 42.3952 40.3966L39.5762 37.254C38.7669 36.3514 38.707 34.9923 39.4338 34.0222C39.9137 33.382 40.678 33 41.4786 33L56.9038 33C58.608 33 60 34.3774 60 36.0931L60 51.5105C60 52.8971 58.8753 54.05 57.4583 54.05C56.8203 54.05 56.2101 53.8129 55.7401 53.3824L52.4466 50.3658C47.8263 54.0055 42.3369 56 36.8947 56Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.cdb81421d73c7fe30de08a1631186a35.svg";
export { ForwardRef as ReactComponent };